/**
 * ajax 请求配置
 */
import axios from 'axios'
import store from '@/store'
import * as ActionTypes from '@/store/action-types'
import Vue from 'vue'

const Qs = require('qs');

// 创建 Loading 实例
// let loadingInstance

let prefix_ms = location.origin;
if (process.env.NODE_ENV === "development") {//开发环境
  prefix_ms = '/cp';
} else {//生产环境
  prefix_ms = location.origin + '/api';
}


class HttpRequest {
  constructor() {
    this.queue = {}
  }
  getInsideConfig() {
    const config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
    return config
  }
  distory(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // loadingInstance.close();
    }
  }
  interceptors(instance, url) {
    instance.defaults.timeout = 50000;   // 超时时间

    // url = prefix_ms + '/v2' + url
    instance.interceptors.request.use(config => {
      if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        config.headers['token'] = store.getters.token
      }
      if (config.method == 'get') {
        // config.params = {
        //   // _t: Date.parse(new Date())/1000,
        //   ...config.params
        // }
      }
      //loading
      if (!Object.keys(this.queue).length) {
        /* loadingInstance = Loading.service({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        }); */
      }
      this.queue[url] = true
      return config
    }, error => {
      // this.distory(url)
      return Promise.reject(error)
    })
    instance.interceptors.response.use(res => {
      this.distory(url)

      const { data } = res
      // const { data } = res
      console.log('response:', res);

      console.log('url:', url, "req = ", res.config.data, data);
      //统一处理如果token失效
      if (data.code == 1000006 || data.code == 1000008 || data.code == 1000007 || data.code == 1000009 || data.code == 200201) {//200201 用户未找到
        store.dispatch(ActionTypes.FED_LOGOUT);
        // Vue.prototype.$toast({
        //   message: "FED_LOGOUT" + data.code,
        //   duration: 1000
        // })
        window.location.reload()
        return
      }
      if (data.code == 0) {
        return data
      } else {
        if (data.msg) {
          Vue.prototype.$toast({
            message: data.msg,
            duration: 1000
          })
        }
        return Promise.reject(new Error(data.msg || 'Error'))
      }

      // return data
    }, error => {
      console.log('请求错误:', url, error);
      this.distory(url)
      // console.log('请求错误',error)
      // if (error.response.status == '404') {
      //   return
      // }
      return Promise.reject(error.response)
    })
  }

  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    console.log(options.headers)
    return instance(options)
  }
}
export default HttpRequest



//////////////////
// WEBPACK FOOTER
// ./app/lib/axios.js
// module id = null
// module chunks = 